let SafeExamBrowser, configKey, browserExamKey, location

export const checkIfSafeExamBrowser = () => Boolean(SafeExamBrowser)

export const checkIfSEBConfigured = () =>
  checkIfSafeExamBrowser() && SafeExamBrowser.security && SafeExamBrowser.security.updateKeys

export const obtainKeys = () => [configKey, browserExamKey, location]

export const header = "X-SafeExamBrowser-RequestHash"

export const obtainHeaders = () => {
  const [_, browserExamKey, location] = obtainKeys()

  if (!browserExamKey || browserExamKey === "") {
    return {}
  }

  return {
    [header]: `${browserExamKey ? ":" + browserExamKey + ":" : ""}${location}`,
  }
}

export const withSafeExamBrowser = () => {
  if (!checkIfSafeExamBrowser()) {
    ;({ SafeExamBrowser } = window)

    if (checkIfSEBConfigured()) {
      SafeExamBrowser.security.updateKeys(() => {
        ;({ browserExamKey, configKey } = SafeExamBrowser.security)
        ;[location] = window.location.href.split("#")
      })

      return SafeExamBrowser
    }

    return undefined
  }

  return SafeExamBrowser
}
